<template>
  <div class="yellow-cart">
    <div class="panel">
      <div class="panel-header">
        <h2 class="panel-title"><i class="fas fa-shopping-cart"></i> 黄车采集</h2>
        <button class="btn btn-primary" @click="startCollection">开始采集</button>
      </div>
      <div class="collection-stats">
        <div class="stat-card">
          <div class="stat-icon"><i class="fas fa-clock"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ collectedCount }}</div>
            <div class="stat-label">已采集数量</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon"><i class="fas fa-sync"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ collectionInterval }}s</div>
            <div class="stat-label">采集间隔</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon"><i class="fas fa-toggle-on"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ isCollecting ? '采集中' : '已停止' }}</div>
            <div class="stat-label">采集状态</div>
          </div>
        </div>
      </div>
      <div class="collection-settings">
        <div class="setting-item">
          <label>采集间隔（秒）</label>
          <input type="number" v-model="collectionInterval" min="1" max="60" class="setting-input">
        </div>
        <div class="setting-item">
          <label>数据源</label>
          <div class="custom-select" @click="toggleSourceDropdown">
            <div class="custom-select-value">
              {{ getSourceLabel }}
            </div>
            <i class="fas fa-chevron-down select-arrow"></i>
            <div v-if="showSourceDropdown" class="custom-select-dropdown">
              <div 
                v-for="source in sourceOptions" 
                :key="source.value" 
                class="dropdown-item"
                :class="{ selected: dataSource === source.value }"
                @click.stop="selectSource(source.value)"
              >
                {{ source.label }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="collected-list">
        <div class="list-header">
          <span>采集记录</span>
          <button class="btn btn-secondary btn-sm" @click="clearRecords">清空记录</button>
        </div>
        <div class="list-content">
          <div v-if="collectedItems.length === 0" class="empty-state">
            <i class="fas fa-inbox"></i>
            <p>暂无采集记录</p>
          </div>
          <div v-for="(item, index) in collectedItems" :key="index" class="collected-item">
            <div class="item-info">
              <div class="item-icon"><i :class="item.icon"></i></div>
              <div class="item-details">
                <div class="item-title">{{ item.title }}</div>
                <div class="item-time">{{ item.time }}</div>
              </div>
            </div>
            <div class="item-actions">
              <button class="btn btn-icon" title="查看详情"><i class="fas fa-eye"></i></button>
              <button class="btn btn-icon" title="删除"><i class="fas fa-trash"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YellowCart',
  data() {
    return {
      isCollecting: false,
      collectedCount: 0,
      collectionInterval: 5,
      dataSource: 'all',
      showSourceDropdown: false,
      sourceOptions: [
        { value: 'all', label: '全部数据' },
        { value: 'products', label: '仅商品' },
        { value: 'users', label: '仅用户' }
      ],
      collectedItems: [],
      collectionTimer: null
    }
  },
  computed: {
    getSourceLabel() {
      const option = this.sourceOptions.find(o => o.value === this.dataSource)
      return option ? option.label : '全部数据'
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  methods: {
    toggleSourceDropdown() {
      this.showSourceDropdown = !this.showSourceDropdown
    },
    handleClickOutside(event) {
      if (!event.target.closest('.custom-select')) {
        this.showSourceDropdown = false
      }
    },
    selectSource(value) {
      this.dataSource = value
      this.showSourceDropdown = false
    },
    startCollection() {
      this.isCollecting = !this.isCollecting
      if (this.isCollecting) {
        this.collectionTimer = setInterval(() => {
          this.collectedCount++
          this.collectedItems.unshift({
            title: '新采集数据 #' + this.collectedCount,
            time: new Date().toLocaleTimeString(),
            icon: 'fas fa-shopping-cart'
          })
          if (this.collectedItems.length > 20) {
            this.collectedItems.pop()
          }
        }, this.collectionInterval * 1000)
      } else {
        clearInterval(this.collectionTimer)
      }
    },
    clearRecords() {
      this.collectedItems = []
      this.collectedCount = 0
    }
  },
  beforeDestroy() {
    if (this.collectionTimer) {
      clearInterval(this.collectionTimer)
    }
  }
}
</script>

<style scoped>
.yellow-cart {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.panel {
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(60, 60, 60, 0.5);
  padding: 25px;
  position: relative;
  overflow: hidden;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 17px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(60, 60, 60, 0.5);
}

.panel-title {
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(90deg, #c4b5fd 0%, #a5f3fc 50%, #bbf7d0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: flex;
  align-items: center;
  gap: 10px;
}

.collection-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.stat-card {
  display: flex;
  align-items: center;
  gap: 15px;
  background: linear-gradient(135deg, rgba(50, 50, 50, 0.9) 0%, rgba(40, 40, 40, 0.9) 100%);
  border-radius: 12px;
  padding: 20px;
  border: 1px solid rgba(70, 70, 70, 0.5);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.stat-card:hover {
  background: linear-gradient(135deg, rgba(55, 55, 55, 0.9) 0%, rgba(45, 45, 45, 0.9) 100%);
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
}

.stat-icon {
  font-size: 28px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(34, 211, 238, 0.2) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  width: 50px;
  height: 50px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(139, 92, 246, 0.3);
}

.stat-info {
  flex: 1;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  background: linear-gradient(90deg, #c4b5fd 0%, #67e8f9 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.stat-label {
  font-size: 13px;
  color: #a5f3fc;
}

.collection-settings {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.setting-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.setting-item label {
  font-size: 14px;
  font-weight: 600;
  color: #c4b5fd;
}

.setting-input,
.setting-select {
  padding: 12px 15px;
  border: 1px solid rgba(139, 92, 246, 0.4);
  border-radius: 8px;
  font-size: 14px;
  background: rgba(40, 40, 40, 0.9);
  color: #c4b5fd;
  transition: all 0.3s ease;
}

.custom-select {
  position: relative;
  min-width: 150px;
  padding: 12px 15px;
  border: 1px solid rgba(139, 92, 246, 0.4);
  border-radius: 8px;
  background: rgba(40, 40, 40, 0.9);
  color: #c4b5fd;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.custom-select:hover {
  border-color: rgba(139, 92, 246, 0.7);
}

.custom-select-value {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.select-arrow {
  font-size: 12px;
  color: rgba(196, 181, 253, 0.6);
  margin-left: 8px;
  transition: transform 0.3s ease;
}

.custom-select-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: rgba(35, 35, 35, 0.98);
  border: 1px solid rgba(139, 92, 246, 0.4);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
  z-index: 100;
  overflow: hidden;
}

.dropdown-item {
  padding: 10px 12px;
  cursor: pointer;
  transition: background 0.2s ease;
  color: #c4b5fd;
}

.dropdown-item:hover {
  background: rgba(139, 92, 246, 0.1);
}

.dropdown-item.selected {
  background: rgba(139, 92, 246, 0.2);
  color: #fff;
}

.setting-input:focus,
.setting-select:focus {
  outline: none;
  border-color: rgba(139, 92, 246, 0.7);
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.15);
}

.collected-list {
  background: linear-gradient(135deg, rgba(45, 45, 45, 0.95) 0%, rgba(35, 35, 35, 0.95) 100%);
  border-radius: 12px;
  padding: 20px;
  border: 1px solid rgba(139, 92, 246, 0.2);
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(139, 92, 246, 0.2);
}

.list-header span {
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(90deg, #c4b5fd 0%, #a5f3fc 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #999;
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 15px;
  opacity: 0.5;
}

.collected-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: rgba(139, 92, 246, 0.1);
  border-radius: 8px;
  margin-bottom: 10px;
  transition: all 0.3s ease;
  border: 1px solid rgba(139, 92, 246, 0.2);
}

.collected-item:last-child {
  margin-bottom: 0;
}

.collected-item:hover {
  background: rgba(139, 92, 246, 0.15);
  transform: translateX(5px);
  border-color: rgba(139, 92, 246, 0.4);
}

.item-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.item-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(34, 211, 238, 0.2) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c4b5fd;
  font-size: 18px;
  border: 1px solid rgba(139, 92, 246, 0.3);
}

.item-title {
  font-size: 14px;
  font-weight: 600;
  color: #c4b5fd;
}

.item-time {
  font-size: 12px;
  color: #a5f3fc;
  margin-top: 4px;
}

.item-actions {
  display: flex;
  gap: 8px;
}

.btn {
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: rgba(100, 100, 100, 0.1);
  transition: left 0.3s ease;
  z-index: -1;
}

.btn:hover::before {
  left: 0;
}

.btn-primary {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.8) 0%, rgba(99, 102, 241, 0.8) 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);
}

.btn-secondary {
  background: linear-gradient(135deg, rgba(107, 114, 128, 0.6) 0%, rgba(75, 85, 99, 0.6) 100%);
  color: #d1d5db;
  border: 1px solid rgba(156, 163, 175, 0.5);
}

.btn-sm {
  padding: 8px 12px;
  font-size: 14px;
}

.btn-icon {
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 6px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.2) 0%, rgba(99, 102, 241, 0.2) 100%);
  color: #c4b5fd;
  border: 1px solid rgba(139, 92, 246, 0.3);
}

.btn-icon:hover {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.35) 0%, rgba(99, 102, 241, 0.35) 100%);
}

.btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
}

@media (max-width: 768px) {
  .collection-stats {
    grid-template-columns: 1fr;
  }

  .collection-settings {
    grid-template-columns: 1fr;
  }
}
</style>